import React, { useEffect, useState } from 'react';
import { addToDb } from '../utilities/fakedb';
import Cart from './producSummary/Cart';
import Products from './products/Products';
import './Shop.css';

const Shop = () => {
///main components call/// 
const [products, setProducts] = useState([]);
const [cart,setCart] = useState([]);

useEffect(()=>{
    fetch('products.json')
    .then(res=>res.json())
    .then(data=>setProducts(data))
},[])
////Button Control Functions///
const btnControl = (ReceiveProduct) => {
    const newCart = [...cart,ReceiveProduct];
    setCart(newCart);
    addToDb(ReceiveProduct.id)
}
return (
    <div className='shop-container'>
        <div className="products">
            <div className='product-container'>
                {
                    products.map(product => <Products 
                    product={product} 
                    btnClick = {btnControl} 
                    key={product.id}>
                    </Products>)
                }
            </div>
        </div>
        <div className="cart-Container">
            {<Cart cart={cart}></Cart>}
        </div>  
    </div>
) 
}








export default Shop;
